import React from 'react';
import type { FC } from 'react';

import type { ISidebarOwnProps } from './interfaces';

import { SidebarDrawer } from './components/SidebarDrawer';
import { useLayoutContext } from '../Layout';

export const Sidebar: FC<ISidebarOwnProps> = ({ menuItems }) => {
    const { withoutSidebar } = useLayoutContext();

    if (withoutSidebar) return null;

    return <SidebarDrawer menuItems={menuItems} />;
};
